<template>
  <v-card>
    <v-container fluid grid-list-md>
      <v-layout row>
        <v-flex xs12>
          <payment-config :items="paymentMethods"></payment-config>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
  import PaymentConfig from '@/components/Common/Rental/Locations/PaymentConfig'

  export default {
    name: 'Information',

    components: {
      PaymentConfig,
    },

    props: {
      location: Object,
    },

    computed: {
      paymentMethods () {
        if (!this.location) {
          return []
        }
        return this.location.vending_machine.settings.payment_methods
      }
    }
  }
</script>

<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Common/Rental/Locations/Information.vue